import { makeStyles, Typography } from "@material-ui/core";
import React from "react";
import logo from "./../../assets/Donna_SIAA_Logo.png";

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: 10,
    width: "100%",
    height: "auto",
    padding: 20,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  logoContainer: {
    display: "flex",
    justifyContent: "center",
  },
  logo: {
    height: 80,
  },
  content: {
    margin: 10,
    textAlign: "center",
  },
  heading: {
    fontSize: 34,
    fontWeight: "bold",
    color: "#00669e",
  },
  subHeading: {
    fontSize: 28,
    margin: 10,
    color: "#00669e",
  },
  agreementDetails: {
    margin: 10,
    fontSize: 18,
    textAlign: "center",
    lineHeight: 2,
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 10,
  },
  button: {
    color: "#195880",
    boxShadow: "none",
    backgroundColor: "#c3d3de",
  },
}));

const SIAAPlanUpgradeInProgress = () => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div>
        <div className={classes.logoContainer}>
          <img className={classes.logo} src={logo} alt="Donna" />
        </div>
        <div className={classes.content}>
          <Typography className={classes.heading} style={{ fontWeight: 900 }}>
            Thank You!
          </Typography>
          <div className={classes.agreementDetails}>
            Our support team is currently processing your manual plan upgrade.<br />
            You will be notified once everything is complete.<br/> In the meantime,
            please hold tight as we finalize the upgrade,<br/> and stay tuned for
            your access to all features!
          </div>
        </div>
      </div>
    </div>
  );
};

export default SIAAPlanUpgradeInProgress;
